import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Box, Typography, Button, Grid } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import { notifyError } from "../../utils/notify";
import { useAuth } from "../../hooks/Services/AuthContext";
import RenderWishlist from "./RenderWishlist";
import "./Wishlist.scss";

const API_URL = process.env.REACT_APP_API_URL;

const Wishlists = () => {
    const [data, setData] = useState([]);
    const token = Cookies.get("token");
    const { user } = useAuth();
    const intl = useIntl();

    useEffect(() => {
        const fetchWishlist = async () => {
            if (!token || !user) return;

            try {
                const res = await fetch(`${API_URL}/wishlists/me`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!res.ok) {
                    console.error("Failed to fetch wishlist:", await res.json());
                    return;
                }

                const json = await res.json();
                setData(json.data?.products || []);
            } catch (err) {
                console.error("Error fetching wishlist:", err);
            }
        };

        fetchWishlist();
    }, [token, user]);

    const handleRemove = async (documentId) => {
        try {
            const res = await fetch(`${API_URL}/wishlists/me`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ data: { remove: [documentId] } }),
            });
            if (!res.ok) throw new Error(`PUT /wishlists/me ${res.status}`);
            setData((prev) => prev.filter((p) => p.documentId !== documentId));
        } catch (err) {
            console.error("Error removing from wishlist:", err);
            notifyError(intl.formatMessage({ id: "wishlist_remove_failed", defaultMessage: "Nie udało się usunąć z listy życzeń." }));
        }
    };

    if (!user) {
        return (
            <Box className="wishlist not-logged-in">
                <Box className="wishlist-page">
                    <Box className="wishlist-header">
                        <Typography variant="h4"><FormattedMessage id="wishlist_title" defaultMessage="Twoja lista życzeń" /></Typography>
                    </Box>
                    <Box className="empty-wishlist">
                        <Typography>
                            <FormattedMessage id="wishlist_create_prompt" defaultMessage="Chcesz stworzyć listę życzeń?" />{" "}
                            <Button
                                href="/register"
                                variant="contained"
                                id="register-wishlist"
                            >
                                <FormattedMessage id="wishlist_join_cta" defaultMessage="Dołącz do nas i utwórz swoją listę życzeń!" />
                            </Button>
                        </Typography>
                        <Typography>
                            <FormattedMessage id="wishlist_have_account" defaultMessage="Masz już konto?" />{" "}
                            <Button href="/login" variant="contained" id="login-wishlist">
                                <FormattedMessage id="wishlist_login_cta" defaultMessage="Zaloguj się i utwórz swoją listę życzeń!" />
                            </Button>
                        </Typography>
                    </Box>
                </Box>
            </Box>
        );
    }

    return (
        <Box className="wishlist">
            <Box className="wishlist-page">
                <Box className="wishlist-header">
                    <Typography id="wishlist-title" variant="h4">
                        <FormattedMessage id="wishlist_title" defaultMessage="Twoja lista życzeń" />
                    </Typography>
                    <Typography id="wishlist-desc" variant="subtitle1">
                        <FormattedMessage id="wishlist_desc" defaultMessage="Twoje produkty zapisane na później" /> ❤️
                    </Typography>
                </Box>

                {data.length > 0 ? (
                    <RenderWishlist items={data} onRemove={handleRemove} />
                ) : (
                    <Box className="empty-wishlist">
                        <Typography><FormattedMessage id="wishlist_empty" defaultMessage="Twoja lista życzeń jest pusta" /> 😔</Typography>
                        <Button href="/products" variant="contained" color="primary">
                            <FormattedMessage id="wishlist_start_shopping" defaultMessage="Rozpocznij zakupy" />
                        </Button>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default Wishlists;
